export { VideoCaptureRecording } from './VideoCaptureRecording';
export { type VideoCaptureRecordingProps } from './VideoCaptureRecording.types';
